import { api } from '@xtnd/web/shared/api'
import type {
  ArchivalConfiguration,
  ArchivalHealthData,
  ArchivalServiceInfo,
  CreateArchivalConfigDto,
  ArchivalTestResult,
} from '@xtnd/web/features/archival/types/archivalType';

class ArchivalApi {
  private baseResource = '/external-archival';

  async getConfigurations(): Promise<ArchivalConfiguration[]> {
    return api.get<ArchivalConfiguration[]>(`${this.baseResource}/configurations`);
  }

  async getHealthStatus(): Promise<ArchivalHealthData | undefined> {
    return api.get<ArchivalHealthData>(`${this.baseResource}/health`);
  }

  async getSupportedServices(): Promise<ArchivalServiceInfo[]> {
    return api.get<ArchivalServiceInfo[]>(`${this.baseResource}/services`);
  }

  async createConfiguration(data: CreateArchivalConfigDto): Promise<ArchivalConfiguration> {
    // Use JWT-based endpoint that extracts tenant ID from token
    return api.post<ArchivalConfiguration>(`${this.baseResource}/config`, data);
  }

  async updateConfiguration(
    tenantId: string,
    serviceId: string,
    data: CreateArchivalConfigDto
  ): Promise<ArchivalConfiguration> {
    return api.put<ArchivalConfiguration>(
      `${this.baseResource}/configurations/${tenantId}/${serviceId}`,
      data
    );
  }

  async deleteConfiguration(tenantId: string, serviceId: string): Promise<void> {
    await api.delete(`${this.baseResource}/configurations/${tenantId}/${serviceId}`);
  }

  async validateConfiguration(tenantId: string, data: CreateArchivalConfigDto): Promise<ArchivalTestResult> {
    return api.post(`${this.baseResource}/config/validate`, data);
  }

  async performHealthCheck(): Promise<void> {
    // Note: This would need to be implemented in the backend if needed
    // Removed console.log for production code cleanliness
  }

  async testConfiguration(data: { configId: string }): Promise<ArchivalTestResult> {
    // Use JWT-based endpoint that extracts tenant ID from token
    return api.post<ArchivalTestResult>(`${this.baseResource}/config/test`, data);
  }
}

export const archivalApi = new ArchivalApi();
